import { AuxiliumComponent } from "../auxilium-component";

export default class Icon extends AuxiliumComponent {
	static observable = ["icon", "colour", "size"];

	constructor() {
		super();

		this.icon ??= "fas fa-icons";
	}

	parsedCallback() {
		if (this.colour) { this.dataset.colour = this.colour; }
		if (this.icon) { this.classList.add(...this.icon.split(" ").filter(Boolean)); }
	}

	attributeChanged(name, oldValue, newValue) {
		switch (name) {
			case "icon":
				if (oldValue) { this.classList.remove(...oldValue.split(" ").filter(Boolean)); }
				if (newValue) { this.classList.add(...newValue.split(" ").filter(Boolean)); }
				break;
			case "colour":
				if (newValue) { this.dataset.colour = this.colour; }
				else { this.removeAttribute("data-colour"); }
				break;
		}
	}
}
